import {Inject, Injectable} from '@angular/core';
import {LOCAL_STORAGE, StorageService} from 'ngx-webstorage-service';
import {environment} from "@environment";

@Injectable({
  providedIn: 'root',
})
export class StorageHelperService {

  constructor(
    @Inject(LOCAL_STORAGE) private storage: StorageService,
  ) {
  }

  retrieveFilters(name: string) {
    if (this.storage.has(name + '-' + environment.localStorageVersion)) {
      return this.storage.get(name + '-' + environment.localStorageVersion);
    } else {
      return null;
    }
  }

  set(name: string, value: any) {
    this.storage.set(name + '-' + environment.localStorageVersion, value);
  }

  setObject(name: string, value: any) {
    this.storage.set(name + '-' + environment.localStorageVersion, {...value});
  }

  remove(name: string) {
    this.storage.remove(name + '-' + environment.localStorageVersion);
  }

  get(name: string) {
    if (this.storage.has(name + '-' + environment.localStorageVersion)) {
      return this.storage.get(name + '-' + environment.localStorageVersion);
    } else {
      return null;
    }
  }

}
